window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  /**
   * _.debounce from lodash
   * 
   * Source: https://github.com/lodash/lodash/blob/master/debounce.js
   * @param {*} func 
   * @param {*} wait 
   * @param {*} options 
   */
  debounce: function(func, wait, options) {
    var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime
  
    var lastInvokeTime = 0
    var leading = false
    var maxing = false
    var trailing = true
  
    // Bypass `requestAnimationFrame` by explicitly setting `wait=0`.
    var useRAF = (!wait && wait !== 0 && typeof root.requestAnimationFrame === 'function')
  
    if (typeof func !== 'function') {
      throw new TypeError('Expected a function')
    }
    wait = +wait || 0
    if (isObject(options)) {
      leading = !!options.leading
      maxing = 'maxWait' in options
      maxWait = maxing ? Math.max(+options.maxWait || 0, wait) : maxWait
      trailing = 'trailing' in options ? !!options.trailing : trailing
    }

    function isObject(value) {
      const type = typeof value
      return value != null && (type == 'object' || type == 'function')
    }
  
    function invokeFunc(time) {
      var args = lastArgs
      var thisArg = lastThis
  
      lastArgs = lastThis = undefined
      lastInvokeTime = time
      result = func.apply(thisArg, args)
      return result
    }
  
    function startTimer(pendingFunc, wait) {
      if (useRAF) {
        root.cancelAnimationFrame(timerId)
        return root.requestAnimationFrame(pendingFunc)
      }
      return setTimeout(pendingFunc, wait)
    }
  
    function cancelTimer(id) {
      if (useRAF) {
        return root.cancelAnimationFrame(id)
      }
      clearTimeout(id)
    }
  
    function leadingEdge(time) {
      // Reset any `maxWait` timer.
      lastInvokeTime = time
      // Start the timer for the trailing edge.
      timerId = startTimer(timerExpired, wait)
      // Invoke the leading edge.
      return leading ? invokeFunc(time) : result
    }
  
    function remainingWait(time) {
      var timeSinceLastCall = time - lastCallTime
      var timeSinceLastInvoke = time - lastInvokeTime
      var timeWaiting = wait - timeSinceLastCall
  
      return maxing
        ? Math.min(timeWaiting, maxWait - timeSinceLastInvoke)
        : timeWaiting
    }
  
    function shouldInvoke(time) {
      var timeSinceLastCall = time - lastCallTime
      var timeSinceLastInvoke = time - lastInvokeTime
  
      // Either this is the first call, activity has stopped and we're at the
      // trailing edge, the system time has gone backwards and we're treating
      // it as the trailing edge, or we've hit the `maxWait` limit.
      return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
        (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait))
    }
  
    function timerExpired() {
      var time = Date.now()
      if (shouldInvoke(time)) {
        return trailingEdge(time)
      }
      // Restart the timer.
      timerId = startTimer(timerExpired, remainingWait(time))
    }
  
    function trailingEdge(time) {
      timerId = undefined
  
      // Only invoke if we have `lastArgs` which means `func` has been
      // debounced at least once.
      if (trailing && lastArgs) {
        return invokeFunc(time)
      }
      lastArgs = lastThis = undefined
      return result
    }
  
    function cancel() {
      if (timerId !== undefined) {
        cancelTimer(timerId)
      }
      lastInvokeTime = 0
      lastArgs = lastCallTime = lastThis = timerId = undefined
    }
  
    function flush() {
      return timerId === undefined ? result : trailingEdge(Date.now())
    }
  
    function pending() {
      return timerId !== undefined
    }
  
    function debounced() {
      var time = Date.now()
      var isInvoking = shouldInvoke(time)
  
      // lastArgs = args
      lastArgs = arguments;
      lastThis = this
      lastCallTime = time
  
      if (isInvoking) {
        if (timerId === undefined) {
          return leadingEdge(lastCallTime)
        }
        if (maxing) {
          // Handle invocations in a tight loop.
          timerId = startTimer(timerExpired, wait)
          return invokeFunc(lastCallTime)
        }
      }
      if (timerId === undefined) {
        timerId = startTimer(timerExpired, wait)
      }
      return result
    }
    debounced.cancel = cancel
    debounced.flush = flush
    debounced.pending = pending
    return debounced
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
(function() {
  
  if (window.location.pathname.indexOf('/products') !== -1) {

    var interval_id = window.setInterval(function() {
      
      if ($('#bidding-form').length > 0) {

        $('<span></span>', {
          class: "font-16 pa-text-color est-word",
          text: "ET"
        }).insertAfter('#wk-auction > div.pa-bdr.margin-top-15.pad-15.pa-form-bg.font-arial > div:nth-child(3) > span.font-16.pa-text-color');

        var bidding_amount = $('<span></span>', {
          class: "font-16 font-bold pa-label-color",
          text: "Bidding Amount"
        });

        $('#bidding-form').prepend(bidding_amount);

        var radio_container = $('<div></div>',{
          class: 'radio_container'
        });

        var radio_label = $('<p></p>', {
          class: "font-16 font-bold",
          text: "increase current bid by"
        });

        var container_25 = $('<div></div>',{
          class: 'increment_container'
        });
        var radio_25 = $('<input>', {
          id: 'radio_25',
          class: 'radio_bid',
          type: 'radio',
          name: 'bid',
          value: 25
        });
        var label_25 = $('<label></label>', {
          text: "$ 25",
          for: 'radio_25'
        });

        var container_50 = $('<div></div>',{
          class: 'increment_container'
        });
        var radio_50 = $('<input>', {
          id: 'radio_50',
          class: 'radio_bid',
          type: 'radio',
          name: 'bid',
          value: 50
        });
        var label_50 = $('<label></label>', {
          text: "$ 50",
          for: 'radio_50'
        });

        var container_100 = $('<div></div>',{
          class: 'increment_container'
        });
        var radio_100 = $('<input>', {
          id: 'radio_100',
          class: 'radio_bid',
          type: 'radio',
          name: 'bid',
          value: 100
        });
        var label_100 = $('<label></label>', {
          text: "$ 100",
          for: 'radio_100'
        });

        radio_container.append(radio_label);
        container_25.append(radio_25);
        container_25.append(label_25);
        radio_container.append(container_25);
        container_50.append(radio_50);
        container_50.append(label_50);
        radio_container.append(container_50);
        container_100.append(radio_100);
        container_100.append(label_100);
        radio_container.append(container_100);
        radio_container.insertBefore('.wk_submit_bid');

        var cust_id = $("#wk-auction").attr("cust-id");
        if (!cust_id) {
          var login_prompt = $('<div></div>', {
            class: 'login-requirement',
            text: 'You must be logged in to your account to place a bid'
          });
          login_prompt.insertAfter('div.wk_rm-on-end');
        }

        $('.radio_bid').click(function(e) {
          var bid_value = Number($(e.currentTarget).val());
          var current_val = 0;
          if ($('#wk-auction .width-65 > div:nth-child(2) span.font-16.pa-text-color').length > 0) {
            current_val = Number($('#wk-auction .width-65 > div:nth-child(2) span.font-16.pa-text-color').text().replace('$', ''));
          } else {
            current_val = Number($('#wk-auction .width-65 > div:nth-child(1) span.font-16.pa-text-color').text().replace('$', ''));          
          }
          current_val += bid_value;
          $('#bid_amount').val(current_val);
        });

        $('.pa-text-color').each(function(index, target){
          $(target).text($(target).text().replace('USD', '$'));
          $(target).text($(target).text().replace('.00', ''));
        });

        $('#current_bid').text($('#current_bid').text().replace('$ ', ''));
        $('#current_bid').text($('#current_bid').text().replace('USD ', ''));
        $('#current_bid').text($('#current_bid').text().replace('.00', ''));

        var interval_count_update = 0;          
        var interval_update_id = window.setInterval(function() {
          
          if ($('#current_bid').text().indexOf('USD') !== -1) {
            $('#current_bid').text($('#current_bid').text().replace('$ ', ''));
            $('#current_bid').text($('#current_bid').text().replace('USD ', ''));
            $('#current_bid').text($('#current_bid').text().replace('.00', ''));
            var new_minimum = Number($('#current_bid').text()) + 25;
            $('#label_bid_amt').text('Minimum bidding amount allowed $ ' + new_minimum);
            window.clearInterval(interval_update_id);
          }

          interval_count_update++;

          if (interval_count_update === 20) {
            window.clearInterval(interval_update_id);
          }
        }, 100)          

        $('#bid_amount').attr('placeholder', '');
        $('#bid_amount').val('');
        $('#bid_amount').attr('type', 'number');
        $('#bid_amount').attr('pattern', '[0-9]*');
        $('#bid_amount').attr('onkeypress', 'return event.charCode >= 48 && event.charCode <= 57');

        $('#proxy_bid_amount').attr('type', 'number');
        $('#proxy_bid_amount').attr('pattern', '[0-9]*'); 
        $('#proxy_bid_amount').attr('onkeypress', 'return event.charCode >= 48 && event.charCode <= 57');
        $('#proxy_bid_amount').attr('placeholder', '');

        $('.pa-help .title').text($('.pa-help .title').text().replace('Proxy Bidding', 'Max Bidding'));
        $('.wk_submit_bid').click(function() {
          var interval_count = 0;
          setTimeout(function() {
            var interval_id = window.setInterval(function() {
              var success_btn_visible = $('.pa-success').css('display');
              if (success_btn_visible !== 'none') {  
                
                $('#current_bid').text($('#current_bid').text().replace('USD ', ''));
                $('#current_bid').text($('#current_bid').text().replace('.00', ''));

                $('.radio_bid').prop("checked", false);
                $('.pa-success').addClass('persistent');
        
                $('.pa-success .pa-text-color').click(function() {  
                  $('.pa-success').removeClass('persistent');                 
                });
    
                var new_minimum = Number($('#current_bid').text()) + 25;
                $('#label_bid_amt').text('Minimum bidding amount allowed $ ' + new_minimum);

                checkBidderName();

                window.clearInterval(interval_id);
              } else {
                interval_count++;
              }
              if (interval_count === 200) {
                window.clearInterval(interval_id);
              }
            }, 10);          
          },1000);        
        });

        $('.wk_proxy_submit').click(function() {
          setTimeout(function() {
            $('#current_bid').text($('#current_bid').text().replace('$ ', ''));
            $('#current_bid').text($('#current_bid').text().replace('USD ', ''));
            $('#current_bid').text($('#current_bid').text().replace('.00', ''));
            var new_minimum = Number($('#current_bid').text()) + 25;
            $('#label_bid_amt').text('Minimum bidding amount allowed $ ' + new_minimum);
            checkBidderName();
          }, 1000);
        });

        spObj.socket.on('placeBid', function(response) {
          $('#current_bid').text($('#current_bid').text().replace('$ ', ''));
          $('#current_bid').text($('#current_bid').text().replace('USD ', ''));
          $('#current_bid').text($('#current_bid').text().replace('.00', ''));
          var new_minimum = Number($('#current_bid').text()) + 25;
          $('#label_bid_amt').text('Minimum bidding amount allowed $ ' + new_minimum);
          checkBidderName();
        });
              
        checkBidderName();

        // setTimeout(function() {
        //   checkSocketConnection();
        // }, 5000);

        clearInterval(interval_id);
      }

    }, 250);  

    function checkSocketConnection() {
      var socket_interval_id = window.setInterval(function() {
        if (!spObj.socket.connected) {
          console.log("Socket disconnected, reloading auction");
          $('<p class="conection_problem">The connection with the server is lost. Please check the Internet connection on your device and refresh the page.</p>').insertBefore('#wk-auction');
          window.clearInterval(socket_interval_id);
        }
      }, 500);
    }

    function checkBidderName() {
      var cust_id = $("#wk-auction").attr("cust-id");
      var auction_id = $("#wk-auction").find("input[name='auction_id']").val();

      $.ajax({
        url: spObj.api_url+"index.php?p=wk_ajax_process",
          type: "GET",
            crossDomain: true,
            jsonpCallback: "show_bids",
            cache:false,
            async:false,
            dataType: "jsonp",
        data: { shop_name : spObj.shop_name, auction_id : auction_id, cust_id : cust_id, page: spObj.page, timediff: spObj.timediff },				
        success: function(response) {
          
          if(Number(response['bid_count'])>0)
          {
            // $("#wk-auction").append(response['bidders']);
            if ($('.highest_bidder').length > 0) {
              $('.highest_bidder').remove();
            }
            var winner = $(response['bidders']).find('tbody').find('td:eq(0)').text();
            if (winner === 'You') {
              $('<p class="highest_bidder">You are the highest bidder!</p>').insertBefore('#bidding-form');
            } 
          }
        }     
      });
    }

    var tab_num = 1;
    function adjustHeight(tab_num) {
      var $slide = $('.ProductOverview__infoSlide');
      var $current_slide = $(".ProductOverview__infoSlide:nth-child(".concat(tab_num, ")"));
    
      if ($(window).outerWidth() < 768) {
        $slide = $('.ProductOverview__infoSlide-mobile');
        $current_slide = $(".ProductOverview__infoSlide-mobile:nth-child(".concat(tab_num, ")"));
      }
    
      $slide.css('height', 'auto');
      var item_height = $current_slide.outerHeight();
      $slide.css('height', item_height);
    };

    function swap(tab_num) {
      var $slide = $('.ProductOverview__infoSlide');
    
      if ($(window).outerWidth() < 768) {
        $slide = $('.ProductOverview__infoSlide-mobile');
      }
    
      $('.RegistryCarouselMainContent__sections div').removeClass('Underline');
      var item_width = $slide.outerWidth();
      item_width *= -(tab_num - 1);
      $('.ProductOverview__infoSlider').animate({
        left: item_width
      }, 400);
      $('.ProductOverview__infoTab').removeClass('selected');
      $("[data-number=".concat(tab_num, "]")).addClass('selected'); 
      
      // change the position of the placeholder div depending of the height of the current item
      adjustHeight(tab_num);
    };

    // adjust the width when they resize the window
    window.addEventListener('resize', function() {
      let item_width = $('.ProductOverview__infoSlide').outerWidth();
      item_width *= -(tab_num - 1);
      $('.ProductOverview__slider').css({ left: item_width });  
    });

    if ($('body').hasClass('template-product')) {

      var ourCausesCarouselOptions = {
        arrows: true,
        dots: true,
        infinite: true,
        speed: 500,
        fade: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true
      };

      var slides = $('.ProductOverview__slides');

      if(slides.find('.ProductOverview__slide').length > 1) {
        slides.on('init', function(event, slick){
          $('ProductOverview').find('.ProductOverview__slide[data-slick-index="0"]').addClass('active');
        });

        ourCausesCarousel = slides.slick(ourCausesCarouselOptions);

        $('ProductOverview').find('.ProductOverview__slides').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          $('ProductOverview').find('.ProductOverview__slide').removeClass('active');
        });

        slides.on('afterChange', function(event, slick, currentSlide) {
          $('ProductOverview').find('.ProductOverview__slide[data-slick-index="' + currentSlide + '"]').addClass('active');
        });
      }

      $('.ProductOverview__infoTab').click(function(e) {
        const section_id = $(e.target).data('number');
        tab_num = section_id;
        swap(section_id);
      });

      adjustHeight(1);

      $(window).scroll(slate.utils.debounce(function(e) {
        if ($(window).outerWidth() > 767) {
          var offset = $(window).scrollTop();
          var $image_container = $('.ProductOverview__image');  
          var bottom_image_container = $image_container.position().top + $image_container.outerHeight(true);
    
          var $info_container = $('.ProductOverview__info');  
          var height_info_container = $info_container.outerHeight(false);
          var limit = bottom_image_container - height_info_container;
    
          if (limit > offset) {
            $info_container.animate({
              'margin-top': "".concat(offset, "px")
            }, 40);
          } 
          else {
            $info_container.animate({
              'margin-top': "".concat(limit, "px")
            }, 40);
          }
        }      
      },25));   

    }
  }
  
})();
$(window).scroll(function() {
  ($(document).scrollTop() > 0) ? $('body').addClass('scrolled') : $('body').removeClass('scrolled');
});

$(window).scroll();

var utcDiff = -7; // West coast is UTC-7

function getCountDown(countDownDate, container) {
  var countdownHtml = "";

  if(countDownDate == '') {
    container.text('Coming Soon');

    /*if($('body').hasClass('template-collection')) {
      window.location.href = '/pages/experiences';
    }*/
  } else {
    countDownDate = parseInt(countDownDate);
    countDownDate *= 1000;  // to ms

    // Update the count down every 1 second
    var countdownInterval = setInterval(function() {
      // Get todays date and time
      var now = new Date();
      var nowTimeinWestCoast = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours() + utcDiff, now.getUTCMinutes(), now.getUTCSeconds()).getTime();

      // Find the distance between now an the count down date
      var distance = countDownDate - nowTimeinWestCoast;

      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      //days = (days < 10) ? '0' + String(days) : String(days);
      //hours = (hours < 10) ? '0' + String(hours) : String(hours);
      //minutes = (minutes < 10) ? '0' + String(minutes) : String(minutes);
      //seconds = (seconds < 10) ? '0' + String(seconds) : String(seconds);

      // If the count down is finished, write some text
      if(distance < 0) {
        clearInterval(countdownInterval);

        if(container.data('winner') === true) {
          var countDownDateObject = new Date(countDownDate);
          container.text(countDownDateObject.getUTCMonth() + 1 + '.' + countDownDateObject.getUTCDate() + '.' + countDownDateObject.getUTCFullYear().toString().substr(-2));
        } else {
          container.text('Ended');

          if($('.template-collection').length) {
            var p = container.parent().parent().parent();
            p.find('.btn').first().remove();

            // Remove large text and products for ended experiences only
            $('.template-collection .enter-to-win').remove();
          }
        }
      } else {
        if(days > 0) {
          clearInterval(countdownInterval);

          if(days > 1) {
            container.text(String(days) + ' days remaining');
          } else {
            container.text(String(days) + ' day remaining');
          }
        } else {
          if(hours > 0) {
            var hoursLabel = (hours > 1) ? 'hours' : 'hour';
            var minutesLabel = (minutes > 1) ? 'minutes' : 'minute';
            var secondsLabel = (seconds > 1) ? 'seconds' : 'second';
            container.text(String(hours) + ' ' + hoursLabel + ' ' + String(minutes) + ' ' + minutesLabel + ' ' + String(seconds) + ' ' + secondsLabel + ' remaining');
          }
        }
      }
    }, 1000);
  }
}

function isCollectionLive(countDownDate) {
  if(countDownDate == '') { // Coming soon considered as live
    distance = 1;
  } else {
    countDownDate = parseInt(countDownDate);
    countDownDate *= 1000;  // to ms

    // Get todays date and time
    var now = new Date();
    var nowTimeinWestCoast = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours() + utcDiff, now.getUTCMinutes(), now.getUTCSeconds()).getTime();

    // Find the distance between now an the count down date
    var distance = countDownDate - nowTimeinWestCoast;
  }

  var isLive = (distance <= 0) ? false : true;
  return isLive;
}

function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function addItemsToTheCart(itemsToAdd, button) {
  if(itemsToAdd.length) {
    var item = itemsToAdd.pop();

    $.ajax({
      url: '/cart/add',
      dataType: 'json',
      type: 'post',
      data: item,
      success: function(data) {
        // Update the cart in top bar
        var currentCart = parseInt($('#topBar .cart-item span').text());
        $('#topBar .cart-item span').text(currentCart + 1);

        addItemsToTheCart(itemsToAdd, button);
      },
      error: function(e) {
        console.log('Error: cannot add the item to the cart', e);
      }
    });
  } else {
    // Remove the loader
    button.removeClass('adding');

    // Update the cart in top bar
    if(parseInt($('#topBar .cart-item span').text()) > 0) {
      $('#topBar .cart-item').addClass('active');
    }

    refreshCart();
  }
}

(function() {
  $('.hamburger').click(function() {
    $('html').toggleClass('menu-open');
    $('html').removeClass('cart-open');
  });

  // Close the cart or mobile nav by clicking the overlay
  $('.menu-overlay').click(function() {
    console.log('click overlay');
    $('html').removeClass('menu-open').removeClass('cart-open');
  });

  // Close the mobile nav by clicking on the X
  $(document).on('click', '.mobile-menu .close', function() {
    $('html').removeClass('menu-open');
  });
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

(function() {
  var homeContainer = $('#homeCarousel');
  var currentHomeSlide = 0;
  var currentTimer = 0;
  var timerInterval = null;
  var timerMs = 10000;
  var homeCarousel = null;
  var hoverEnabled = true;  // Can be disabled when the admin edit the slides
  var homeCarouselOptions = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    fade: false,
    autoplay: true,
    autoplaySpeed: timerMs,
    //pauseOnHover: true, // do not use, it restarts from 0 on mouse out
    responsive: [
      {
        breakpoint: 768,
        settings: {
          adaptiveHeight: true,
          pauseOnHover: false,
          pauseOnFocus: false
        }
      }
    ]
  };

  if(homeContainer.length) {
    // Init the countdowns
    $(homeContainer.find('.countdown')).each(function() {
      getCountDown($(this).data('end-timestamp'), $(this));
    });

    window.setTimeout(function() {
      /*
      // Init the scrollbars
      var scrollbarsInit = 0;
      homeContainer.find('.scrollbar-macosx').scrollbar({
        "onInit": function() {
          scrollbarsInit++;

          if(scrollbarsInit == homeContainer.find('.slide').length) {
            initHomeCarousel();
          }
        }
      });
      */
      initHomeCarousel();
    }, 1000);

    homeContainer.mouseenter(function() {
      pauseCarousel();
    });

    homeContainer.mouseleave(function() {
      resumeCarousel();
    });

    homeContainer.find('.slides').on('afterChange', function(event, slick, currentSlide) {
      // Reinit the speed, it could have been changed when rollovered
      homeCarousel.slick('slickSetOption', 'autoplaySpeed', timerMs);

      if(currentHomeSlide != currentSlide) {
        currentHomeSlide = currentSlide;
        homeContainer.find('.control-item').removeClass('active');
        homeContainer.find('.control-item').eq(currentSlide).addClass('active');

        //animateSlide(homeContainer.find('.slide').eq(currentSlide));
        animateSlide();
      }
    });

    $(document).on('click', '#homeCarousel .control-item', function(e) {
      e.preventDefault();
      homeCarousel.slick('slickGoTo', parseInt($(this).data('goto')) - 1, false);
    });

    function pauseCarousel() {
      if(!$('html').hasClass('touchevents')) {
        homeContainer.addClass('hovered');
        clearInterval(timerInterval);

        if(homeCarousel != null) {
          homeCarousel.slick('slickPause');
          homeCarousel.slick('slickSetOption', 'autoplaySpeed', timerMs - (currentTimer * 100));
        }
      }
    }

    function resumeCarousel() {
      if(!$('html').hasClass('touchevents') && hoverEnabled) {
        homeContainer.removeClass('hovered');
        startTimer();

        if(homeCarousel != null) {
          homeCarousel.slick('slickPlay');
        }
      }
    }

    function initHomeCarousel() {
      homeContainer.find('.slides').off('init');
      homeContainer.find('.slides').on('init', function(event, slick) {
        homeContainer.addClass('init');

        if(!hoverEnabled) {
          pauseCarousel();
        }

        animateSlide();
      });

      homeCarousel = homeContainer.find('.slides').slick(homeCarouselOptions);

      homeContainer.find('.control-item').first().addClass('active');
    }

    /*
    // Unofficial unslick callback
    homeContainer.find('.slides').on('destroy', function(event, slick) {
      console.log('destroy', homeCarousel);
      // Re-initialize with the old settings.
      //homeCarousel = homeContainer.find('.slides').slick(slick.options);
    });
    */

    function startTimer() {
      if(hoverEnabled) {
        currentTimer = 0;
        clearInterval(timerInterval);
        timerInterval = setInterval(function() {
          currentTimer += 1;
        }, 100);
      }
    }

    function animateSlide() {
      startTimer();

      homeContainer.find('.slides .slide *').removeClass('animate').removeClass('slide-right');

      homeContainer.find('.slick-current').find('h4').addClass('animate slide-right');
      setTimeout(function() {homeContainer.find('.slick-current .title-top').addClass('animate slide-right');}, 200);
      setTimeout(function() {homeContainer.find('.slick-current .title-bottom').addClass('animate slide-right');}, 400);
      setTimeout(function() {homeContainer.find('.slick-current .caption').addClass('animate slide-right');}, 600);
      setTimeout(function() {homeContainer.find('.slick-current .btn').addClass('animate slide-right');}, 800);
    }
  }

  /*** Shopify event for admin side ***/

  $(document).on('shopify:section:unload', function(e) {
    var sectionId = e.detail.sectionId;

    if($('#shopify-section-' + sectionId + ' #homeCarousel').length) {
      homeCarousel.slick('unslick');
    }
  });

  $(document).on('shopify:section:load', function(e) {
    var sectionId = e.detail.sectionId;
    var blockId = e.detail.blockId;

    if($('#shopify-section-' + sectionId + ' #homeCarousel').length) {
      homeContainer = $('#homeCarousel'); // This is the HUGE trick
      initHomeCarousel();
    }
  });

  $(document).on('shopify:block:select', function(e) {
    var sectionId = e.detail.sectionId;
    var blockId = e.detail.blockId;

    if($('#shopify-section-' + sectionId + ' #homeCarousel').length) {
      // hovering the carousel in the preview window is disabled during this time
      hoverEnabled = false;

      // Pause the carousel   
      pauseCarousel();

      // Select the correct dot (in case a new slide has been created)
      homeContainer.find('.control-item').removeClass('active');
      var index = parseInt($('#homeSlideId-' + blockId).data('slick-index'));
      homeContainer.find('.control-item').eq(index).addClass('active');

      var index = parseInt($('#homeSlideId-' + blockId).data('slick-index'));

      if(!isNaN(index)) {
        // Go to the correct slide
        homeCarousel.slick('slickGoTo', index, false);
      } else {
        // It's a new slide (see unload / load)
      }
    }
  });

  $(document).on('shopify:block:deselect', function(e) {
    var sectionId = e.detail.sectionId;

    if($('#shopify-section-' + sectionId + ' #homeCarousel').length) {   
      // Resume regular actions in preview window
      hoverEnabled = true;

      // Resume the carousel, 
      resumeCarousel();
    }
  });
})();
(function() {
  var homeTrendingContainer = $('#homeTrending');
  var homeTrendingCarousel = null;
  var homeTrendingCarouselOptions = {
    slidesToShow: 3,
    arrows: true,
    dots: false,
    infinite: false,
    speed: 500,
    autoplaySpeed: 4000,
    variableWidth: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  if(homeTrendingContainer.length) {
    homeTrendingContainer.find('.slides').on('init', function(event, slick){
      homeTrendingContainer.find('.slide[data-slick-index="0"]').addClass('active').addClass('anim-complete');

      if($(window).width() > 991) {
        homeTrendingContainer.find('.slide[data-slick-index="-1"]').addClass('active').addClass('anim-complete');
      }
    });

    homeTrendingCarousel = homeTrendingContainer.find('.slides').slick(homeTrendingCarouselOptions);

    homeTrendingCarousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      homeTrendingContainer.find('.slide').removeClass('active').removeClass('anim-complete');
      homeTrendingContainer.find('.slide[data-slick-index="' + nextSlide + '"]').addClass('active');

      if($(window).width() > 991) {
        homeTrendingContainer.find('.slide[data-slick-index="' + String(parseInt(nextSlide) - 1) + '"]').addClass('active');
      }
    });

    homeTrendingCarousel.on('afterChange', function(event, slick, currentSlide) {
      homeTrendingContainer.find('.slide[data-slick-index="' + currentSlide + '"]').addClass('anim-complete');

      if($(window).width() > 991) {
        homeTrendingContainer.find('.slide[data-slick-index="' + String(parseInt(currentSlide) - 1) + '"]').addClass('anim-complete');
      }
    });

    $(homeTrendingContainer.find('.countdown')).each(function() {
      getCountDown($(this).data('end-timestamp'), $(this));
    });
  }

  $(window).resize(function() {
    if($(window).width() > 991) {
      homeTrendingContainer.find('.slick-slide[data-slick-index="' + String(parseInt(homeTrendingContainer.find('.slick-current').data('data-slick-index')) - 1) + '"]').addClass('active')
    }
  });

  /*** Shopify event for admin side ***/

  $(document).on('shopify:section:unload', function(e) {
    var sectionId = e.detail.sectionId;

    if($('#shopify-section-' + sectionId + ' #homeTrending').length) {
      homeTrendingCarousel.slick('unslick');  // Doesn't seem required, just in case
    }
  });

  $(document).on('shopify:section:load', function(e) {
    var sectionId = e.detail.sectionId;

    if($('#shopify-section-' + sectionId + ' #homeTrending').length) {
      homeTrendingContainer = $('#homeTrending');
      //$('#homeTrending .slides').slick(homeTrendingCarouselOptions);
      homeTrendingCarousel = homeTrendingContainer.find('.slides').slick(homeTrendingCarouselOptions);
    }
  });

  $(document).on('shopify:block:select', function(e) {
    var sectionId = e.detail.sectionId;
    var blockId = e.detail.blockId;

    if($('#shopify-section-' + sectionId + ' #homeTrending').length) {
      var index = parseInt($('#homeTrendingSlideId-' + blockId).data('slick-index'));

      if(!isNaN(index)) {
        // Go to the correct slide
        homeTrendingCarousel.slick('slickGoTo', index, false);
      } else {
        // It's a new slide
      }
    }
  });
})();
(function() {
  var ourCausesContainer = $('#ourCauses');
  var ourCausesCarousel = null;
  var ourCausesCarouselOptions = {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    fade: false,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true
  };

  if(ourCausesContainer.length) {

    var photoSlides = ourCausesContainer.find('.slides:not(.collection-cause)');
    var causeSlides = ourCausesContainer.find('.causes-container');
    var slides;

    if (photoSlides.length > 0) {
      slides = photoSlides;
    } else {
      slides = causeSlides;
    }

    if(slides.find('.slide').length > 1) {
      slides.on('init', function(event, slick){
        ourCausesContainer.find('.slide[data-slick-index="0"]').addClass('active');
      });

      ourCausesCarousel = slides.slick(ourCausesCarouselOptions);

      ourCausesContainer.find('.slides').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        ourCausesContainer.find('.slide').removeClass('active');
      });

      slides.on('afterChange', function(event, slick, currentSlide) {
        ourCausesContainer.find('.slide[data-slick-index="' + currentSlide + '"]').addClass('active');
      });
    }

    ourCausesContainer.find('.scrollbar-macosx').scrollbar();
  }

  /*** Shopify event for admin side ***/

  $(document).on('shopify:section:unload', function(e) {
    var sectionId = e.detail.sectionId;

    if($('#shopify-section-' + sectionId + ' #ourCauses').length) {
      ourCausesCarousel.slick('unslick');  // Doesn't seem required, just in case
    }
  });

  $(document).on('shopify:section:load', function(e) {
    var sectionId = e.detail.sectionId;

    if($('#shopify-section-' + sectionId + ' #ourCauses').length) {
      ourCausesContainer = $('#ourCauses');
      ourCausesCarousel = ourCausesContainer.find('.slides').slick(ourCausesCarouselOptions);
    }
  });

  $(document).on('shopify:block:select', function(e) {
    var sectionId = e.detail.sectionId;
    var blockId = e.detail.blockId;

    if($('#shopify-section-' + sectionId + ' #ourCauses').length) {
      var index = parseInt($('#ourCausesSlideId-' + blockId).data('slick-index'));

      if(!isNaN(index)) {
        // Go to the correct slide
        ourCausesCarousel.slick('slickGoTo', index, false);
      }
    }
  });
})();

(function() {
  if($('#joinOurCause').length) {
    $(document).on('click', '#joinOurCause .submit' , function() {
      var err = '';

      $('#joinOurCause .error').removeClass('active');

      if($('#join-email').val() == '') {
        err = 'Please enter your email.';
      } else {
        if(!validateEmail($('#join-email').val())) {
          err = 'Please enter a valid email.';
        }
      }

      // Submit to service
      if(err == '') {
        $('#joinOurCause form').submit().addClass('sent');
        $('#joinOurCause .form-sent').addClass('active');
      } else {
        $('#joinOurCause .error').text(err).addClass('active');
      }
    });
  }
})();
(function() {
  var asFeaturedInContainer = $('#asFeaturedIn');
  var asFeaturedInCarousel = null;
  var asFeaturedInOptions = {
    slidesToShow: 3,
    arrows: false,
    dots: false,
    autoplay: false,
    responsive: [
      /*{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          arrows: true,
          speed: 500,
          autoplay: false,
          autoplaySpeed: 4000,
          pauseOnHover: true
        }
      },*/
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
          speed: 500,
          autoplay: false,
          autoplaySpeed: 4000,
          pauseOnHover: true
        }
      }
    ]
  };

  if(asFeaturedInContainer.length) {
    asFeaturedInCarousel = asFeaturedInContainer.find('.slides').slick(asFeaturedInOptions);
  }

  /*** Shopify event for admin side ***/

  $(document).on('shopify:section:unload', function(e) {
    var sectionId = e.detail.sectionId;

    if($('#shopify-section-' + sectionId + ' #asFeaturedIn').length) {
      asFeaturedInCarousel.slick('unslick');  // Doesn't seem required, just in case
    }
  });

  $(document).on('shopify:section:load', function(e) {
    var sectionId = e.detail.sectionId;

    if($('#shopify-section-' + sectionId + ' #asFeaturedIn').length) {
      asFeaturedInContainer = $('#asFeaturedIn');
      asFeaturedInCarousel = asFeaturedInContainer.find('.slides').slick(asFeaturedInOptions);
    }
  });

  $(document).on('shopify:block:select', function(e) {
    var sectionId = e.detail.sectionId;
    var blockId = e.detail.blockId;

    if($('#shopify-section-' + sectionId + ' #asFeaturedIn').length) {
      var index = parseInt($('#asFeaturedInSlideId-' + blockId).data('slick-index'));

      if(!isNaN(index)) {
        // Go to the correct slide
        asFeaturedInCarousel.slick('slickGoTo', index, false);
      }
    }
  });
})();
var showingNextExperiences = true;
var expPerPage = 2;
var currentExperienceRow = 1;
var currentPageType = 'live';

(function() {
  if($('#experiences').length) {
    var showByGroupOf = 50; // Show x experiences when the page loads, load x extra experiences when clicking "load more". Must be even.
    var defaultTimestamp = '4102444800';  // 01/01/2100 //Math.floor(Date.now() /1000);

    var currentLiveIndex = 3;
    var currentPastIndex = 3;

    var live = [];
    var past = [];

    // We're loading 50 collections.
    // PM confirmed that's enough, if we need more, we'll need to paginate in the future (load multiple pages before showing the items).
    //$.getJSON('/collections.json?page=1&limit=250', function(data) {
    $.get('/pages/experiences-data', function(data) {
      data = $.parseJSON(data);
      var collections = data.collections;

      // Re-order the collections by time left
      var reorderedCollections = [];
      var metafields = null;
      $.each(collections, function(index, collection) {
        console.log('handle', collection.handle);
        collection.end_timestamp = defaultTimestamp;

        if(collection.metafields.end_timestamp != '') {
          collection.end_timestamp = collection.metafields.end_timestamp;
        }

        if (collection.id != '1791885324' && collection.id != '80412770402' && collection.id != '80284385378') {
          // Exclude a test collection (winner)
          // Exclude a collection (defender)
          // Exclude a collection (nfl)
          reorderedCollections.push(collection);
        }
      });

      reorderedCollections.sort(function(a, b) {
        return parseFloat(a.end_timestamp) - parseFloat(b.end_timestamp);
      });

      //console.log(reorderedCollections);

      var liveHtml = '';
      var pastHtml = '';

      var countLive = 0;
      var countPast = 0;

      var isLiveItemVisible = false;
      var isPastItemVisible = false;

      var metafields = null;
      $.each(reorderedCollections, function(index, collection) {
        if(isCollectionLive(collection.end_timestamp)) {
          if(collection.end_timestamp == defaultTimestamp) {
            collection.end_timestamp = '';
          }

          live.push(collection);

          if(countLive % 2 == 0) {
            if(countLive > 0) {
              liveHtml += '</div>';
            }

            liveHtml += '<div class="row">';
          }

          isLiveItemVisible = (countLive < showByGroupOf) ? true : false;

          liveHtml += getCollectionHtml(collection, isLiveItemVisible);

          countLive++;
        } else {
          past.push(collection);

          if(countPast % 2 == 0) {
            if(countPast > 0) {
              pastHtml += '</div>';
            }
            
            pastHtml += '<div class="row">';
          }

          isPastItemVisible = (countPast < showByGroupOf) ? true : false;

          pastHtml += getCollectionHtml(collection, isPastItemVisible);

          countPast++;
        }
      });

      if(countPast > 0 && countLive > 0) {
        $('#MainContent .sub-nav').addClass('visible');
      } else {
        $('#MainContent .sub-nav').remove();
      }

      // Close last .row
      liveHtml += '</div>';
      pastHtml += '</div>';

      $('.experiences.live .grid').html(liveHtml);
      $('.experiences.past .grid').html(pastHtml);

      //$('.experiences.live .active').addClass('animate');
      showNextExperiences();

      // Init lazyload
      //lazyload(); // doesn't seem to be working with IE

      // Hide 'load more' if no more items to show
      if(live.length <= showByGroupOf) {
        $('.load-more-container').addClass('hidden-live');
        $('.load-more-container a').css('display', 'none');
      }
      if(past.length <= showByGroupOf) {
        $('.load-more-container').addClass('hidden-past');
        $('.load-more-container a').css('display', 'none');
      }

      // Init the countdowns
      $($('.experiences .countdown')).each(function() {
        getCountDown($(this).data('end-timestamp'), $(this));
      });
    });

    $(document).on('click', '.load-more-container', function() {
      var currentIndex = (currentPageType == 'live') ? currentLiveIndex : currentPastIndex;
      var collections = (currentPageType == 'live') ? live : past;
      //console.log(currentIndex, showByGroupOf);

      for(var i = currentIndex + 1; i < currentIndex + 1 + showByGroupOf; i++) {
        if(collections[i] != undefined) {
          $('.experiences [data-handle="' + collections[i].handle + '"]').addClass('active');
        } else {
          // We reached the end of the array
          $('.load-more-container').addClass('hidden-' + currentPageType);
          $('.load-more-container a').css('display', 'none');
        }

        (currentPageType == 'live') ? currentLiveIndex++ : currentPastIndex++;
      }

      currentIndex = (currentPageType == 'live') ? currentLiveIndex : currentPastIndex;
      if(collections[currentIndex + 1] == undefined) {
        $('.load-more-container').addClass('hidden-' + currentPageType);
        $('.load-more-container a').css('display', 'none');
      }
    });

    $(document).on('click', '#experiences .sub-nav a', function() {
      if($(this).data('page') != currentPageType) {
        $('.experiences.' + currentPageType).removeClass('active');
        currentPageType = $(this).data('page');
        $('.experiences.' + currentPageType).addClass('active');
        $('#experiences .sub-nav li').removeClass('active');
        $(this).parent().addClass('active');

        $('.experiences .grid__item').removeClass('animate');
        currentExperienceRow = 1;
        showNextExperiences();

        if($('.load-more-container').hasClass('hidden-' + currentPageType)) {
          $('.load-more-container a').css('display', 'none');
        } else {
          $('.load-more-container a').css('display', 'inline');
        }
      }
    });
  }

  // Show experiences on scroll
  $(window).scroll(function() {
    var c = $('.experiences.' + currentPageType);

    if(currentExperienceRow < c.find('.row').length) {
      var h = $(window).height();

      var currentRowOffset = c.find('.row').eq(currentExperienceRow - 1).offset();
      var currentRowOffsetTop = currentRowOffset.top;
      var currentRowH = c.find('.row').eq(currentExperienceRow - 1).outerHeight();

      if(!showingNextExperiences) {
        if($(document).scrollTop() > currentRowOffsetTop - h + currentRowH + $('#shopify-section-header').outerHeight()) {
          currentExperienceRow++;
          showNextExperiences();
        }
      }
    }
  });
})();

function showNextExperiences() {
  showingNextExperiences = true;
  var c = $('.experiences.' + currentPageType);
  var totalExpToShow = expPerPage * currentExperienceRow;
  var j = 0;

  c.find('.grid__item').each(function(i, p) {
    var item = $(this);

    if(i < totalExpToShow && !item.hasClass('animate')) {
      window.setTimeout(function() {
        item.addClass('animate');

        showingNextExperiences = false;
        $(window).scroll();
      }, 200 * (j + 1));

      j++;
    }
  });
}

// Template for collection item
function getCollectionHtml(exp, isVisible) {
  var html = '';

  var activeClass = (isVisible) ? 'active' : '';
  var comingSoonClass = 'coming-soon';

  //var link = 'javascript:void(0);';

  var link = '/collections/' + exp.handle;
  if (exp.auction) {
    link = '/products/' + exp.handle;
  }
  if(exp.end_timestamp != '') {
    comingSoonClass = '';
  }

  var hasWinner = (exp.metafields.winner_name != '') ? true : false;

  html += '<div class="grid__item medium-up--one-half small--one-whole ' + activeClass + ' ' + comingSoonClass + '" data-handle="' + exp.handle + '" data-products-count="' + exp.products_count + '">';
    html += '<a class="image-container" href="' + link + '">';
      html += '<div class="overlay"></div>';

      console.log('image', exp.image.src);
      if(exp.image != undefined && exp.image.src != undefined) {
        var src = String(exp.image.src).split('.jpg')[0] + '_1200x624_crop_top.jpg';
        html += '<img src="' + src + '" alt="' + exp.title + '" width="100%" />';
        //html += '<img data-src="' + exp.image.src + '" alt="' + exp.title + '" class="lazyload" />';
      }

    html += '</a>';

    html += '<div class="grey-block" onClick="window.location.href=\'' + link + '\';">';
      html += '<h5 class="countdown orange" data-end-timestamp="' + exp.end_timestamp + '" data-winner="' + hasWinner + '"></h5>';

      html += '<h4 class="anton">' + exp.title + '</h4>';

      html += '<a href="' + link + '" class="btn">View experience</a>';
    html += '</div>';

  html += '</div>';

  return html;
}

// This is adapted from lf__experiences.js.  The auction items are using the same html structure as the experiences items.
var showingNextExperiences = true;
var expPerPage = 2;
var currentExperienceRow = 1;
var currentPageType = 'live';

(function() {
  if($('#auctions').length) {
    var showByGroupOf = 50; // Show x experiences when the page loads, load x extra experiences when clicking "load more". Must be even.
    // var defaultTimestamp = '4102444800';  // 01/01/2100 //Math.floor(Date.now() /1000);

    var currentLiveIndex = 3;
    // var currentPastIndex = 3;

    var live = [];
    // var past = [];

    // We're loading 50 collections.
    // PM confirmed that's enough, if we need more, we'll need to paginate in the future (load multiple pages before showing the items).
    //$.getJSON('/collections.json?page=1&limit=250', function(data) {
    $.get('/pages/auction-products-data', function(data) {
      data = $.parseJSON(data);
      // console.log('Auction roduct Data:', data);
      var collections = data.collections;

      // Re-order the collections by time left
      // var reorderedCollections = [];
      // var metafields = null;
      // $.each(collections, function(index, collection) {
      //   // console.log('handle:', collection.handle);
      //   collection.end_timestamp = defaultTimestamp;

      //   if(collection.metafields.end_timestamp != '') {
      //     collection.end_timestamp = collection.metafields.end_timestamp;
      //   }

      //   if (collection.id != '1791885324' && collection.id != '80412770402' && collection.id != '80284385378') {
      //     // Exclude a test collection (winner)
      //     // Exclude a collection (defender)
      //     // Exclude a collection (nfl)
      //     reorderedCollections.push(collection);
      //   }
      // });

      // reorderedCollections.sort(function(a, b) {
      //   return parseFloat(a.end_timestamp) - parseFloat(b.end_timestamp);
      // });

      //console.log(reorderedCollections);

      var liveHtml = '';
      // var pastHtml = '';

      var countLive = 0;
      // var countPast = 0;

      var isLiveItemVisible = false;
      // var isPastItemVisible = false;

      // var metafields = null;
      $.each(collections, function(index, collection) {
        // if(isCollectionLive(collection.end_timestamp)) {
          // if(collection.end_timestamp == defaultTimestamp) {
          //   collection.end_timestamp = '';
          // }

          live.push(collection);

          if(countLive % 2 == 0) {
            if(countLive > 0) {
              liveHtml += '</div>';
            }

            liveHtml += '<div class="row">';
          }

          isLiveItemVisible = (countLive < showByGroupOf) ? true : false;

          liveHtml += getAuctiontionHtml(collection, isLiveItemVisible);

          countLive++;
        // } 
        // else {
        //   past.push(collection);

        //   if(countPast % 2 == 0) {
        //     if(countPast > 0) {
        //       pastHtml += '</div>';
        //     }
            
        //     pastHtml += '<div class="row">';
        //   }

        //   isPastItemVisible = (countPast < showByGroupOf) ? true : false;

        //   pastHtml += getAuctiontionHtml(collection, isPastItemVisible);

        //   countPast++;
        // }
      });

      // if(countPast > 0 && countLive > 0) {
      //   $('#MainContent .sub-nav').addClass('visible');
      // } else {
      //   $('#MainContent .sub-nav').remove();
      // }

      // Close last .row
      liveHtml += '</div>';
      // pastHtml += '</div>';

      $('.experiences.live .grid').html(liveHtml);
      // $('.experiences.past .grid').html(pastHtml);

      //$('.experiences.live .active').addClass('animate');
      showNextExperiences();

      // Init lazyload
      //lazyload(); // doesn't seem to be working with IE

      // Hide 'load more' if no more items to show
      if(live.length <= showByGroupOf) {
        $('.load-more-container').addClass('hidden-live');
        $('.load-more-container a').css('display', 'none');
      }
      // if(past.length <= showByGroupOf) {
      //   $('.load-more-container').addClass('hidden-past');
      //   $('.load-more-container a').css('display', 'none');
      // }

      // Init the countdowns
      // $($('.experiences .countdown')).each(function() {
      //   getCountDown($(this).data('end-timestamp'), $(this));
      // });
    });

    $(document).on('click', '.load-more-container', function() {
      var currentIndex = (currentPageType == 'live') ? currentLiveIndex : currentPastIndex;
      var collections = (currentPageType == 'live') ? live : past;
      //console.log(currentIndex, showByGroupOf);

      for(var i = currentIndex + 1; i < currentIndex + 1 + showByGroupOf; i++) {
        if(collections[i] != undefined) {
          $('.experiences [data-handle="' + collections[i].handle + '"]').addClass('active');
        } else {
          // We reached the end of the array
          $('.load-more-container').addClass('hidden-' + currentPageType);
          $('.load-more-container a').css('display', 'none');
        }

        (currentPageType == 'live') ? currentLiveIndex++ : currentPastIndex++;
      }

      currentIndex = (currentPageType == 'live') ? currentLiveIndex : currentPastIndex;
      if(collections[currentIndex + 1] == undefined) {
        $('.load-more-container').addClass('hidden-' + currentPageType);
        $('.load-more-container a').css('display', 'none');
      }
    });

    // $(document).on('click', '#experiences .sub-nav a', function() {
    //   if($(this).data('page') != currentPageType) {
    //     $('.experiences.' + currentPageType).removeClass('active');
    //     currentPageType = $(this).data('page');
    //     $('.experiences.' + currentPageType).addClass('active');
    //     $('#experiences .sub-nav li').removeClass('active');
    //     $(this).parent().addClass('active');

    //     $('.experiences .grid__item').removeClass('animate');
    //     currentExperienceRow = 1;
    //     showNextExperiences();

    //     if($('.load-more-container').hasClass('hidden-' + currentPageType)) {
    //       $('.load-more-container a').css('display', 'none');
    //     } else {
    //       $('.load-more-container a').css('display', 'inline');
    //     }
    //   }
    // });
  }

  // Show experiences on scroll
  $(window).scroll(function() {
    var c = $('.experiences.' + currentPageType);

    if(currentExperienceRow < c.find('.row').length) {
      var h = $(window).height();

      var currentRowOffset = c.find('.row').eq(currentExperienceRow - 1).offset();
      var currentRowOffsetTop = currentRowOffset.top;
      var currentRowH = c.find('.row').eq(currentExperienceRow - 1).outerHeight();

      if(!showingNextExperiences) {
        if($(document).scrollTop() > currentRowOffsetTop - h + currentRowH + $('#shopify-section-header').outerHeight()) {
          currentExperienceRow++;
          showNextExperiences();
        }
      }
    }
  });
})();

// function showNextExperiences() {
//   showingNextExperiences = true;
//   var c = $('.experiences.' + currentPageType);
//   var totalExpToShow = expPerPage * currentExperienceRow;
//   var j = 0;

//   c.find('.grid__item').each(function(i, p) {
//     var item = $(this);

//     if(i < totalExpToShow && !item.hasClass('animate')) {
//       window.setTimeout(function() {
//         item.addClass('animate');

//         showingNextExperiences = false;
//         $(window).scroll();
//       }, 200 * (j + 1));

//       j++;
//     }
//   });
// }

// Template for collection item
function getAuctiontionHtml(exp, isVisible) {
  var html = '';

  var activeClass = (isVisible) ? 'active' : '';
  // var comingSoonClass = 'coming-soon';

  //var link = 'javascript:void(0);';

  var link = '/collections/' + exp.handle;
  if (exp.auction) {
    link = '/products/' + exp.handle;
  }
  // if(exp.end_timestamp != '') {
  //   comingSoonClass = '';
  // }

  var hasWinner = (exp.metafields.winner_name != '') ? true : false;

  // html += '<div class="grid__item medium-up--one-half small--one-whole ' + activeClass + ' ' + comingSoonClass + '" data-handle="' + exp.handle + '" data-products-count="' + exp.products_count + '">';
  html += '<div class="grid__item medium-up--one-half small--one-whole ' + activeClass + '" data-handle="' + exp.handle + '" data-products-count="' + exp.products_count + '">';
    html += '<a class="image-container" href="' + link + '">';
      html += '<div class="overlay"></div>';

      // console.log('image', exp.image.src);
      if(exp.image != undefined && exp.image.src != undefined) {
        var src = String(exp.image.src).split('.jpg')[0] + '_1200x624_crop_top.jpg';
        html += '<img src="' + src + '" alt="' + exp.title + '" width="100%" />';
        //html += '<img data-src="' + exp.image.src + '" alt="' + exp.title + '" class="lazyload" />';
      }

    html += '</a>';

    html += '<div class="grey-block" onClick="window.location.href=\'' + link + '\';">';
      // html += '<h5 class="countdown orange" data-end-timestamp="' + exp.end_timestamp + '" data-winner="' + hasWinner + '"></h5>';
      html += '<span class="auction-time-left">time left:</span>';
      html += '<div class="wk-category-auction" data-prod="' + exp.id + '"></div>';
      html += '<h5 class="orange">Auction</h5>';

      html += '<h4 class="anton">' + exp.title + '</h4>';

      html += '<a href="' + link + '" class="btn">View experience</a>';
    html += '</div>';

  html += '</div>';

  return html;
}

var showingNextProducts = true;
var itemsPerPage = 2;
var currentPage = 1;

// Show more products on scroll
function showNextProducts() {
  showingNextProducts = true;

  var totalProductsToShow = itemsPerPage * currentPage;
  var j = 0;

  //console.log('showing next product', totalProductsToShow);

  $('#experienceDetails .product-item').each(function(i, p) {
    var item = $(this);

    if(i < totalProductsToShow && !item.hasClass('visible')) {
      item.addClass('visible');
      $(window).resize();

      window.setTimeout(function() {
        item.addClass('animate');
      }, 200 * (j + 1));

      // Init the product image carousels
      initProductImageCarousels(item);

      j++;
    }
  });
}

function showAllProducts() {
  currentPage = $('#experienceDetails .row').length;
  showNextProducts();
}

function initProductImageCarousels(item) {
  var slides = item.find('.slides');
  if(!slides.hasClass('slick-slider') && slides.is(':visible') && item.find('.multiple-images').length) {
    slides.on('init', function(event, slick){
      showingNextProducts = false;
    });

    slides.slick({
      arrows: true,
      //dots: ($(this).find('.slide').length > 1) ? true : false,
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      autoplay: false,
      pauseOnHover: true,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
          }
        }
      ]
    });

    // Update the dots when swiping the carousel or interacting with the dots
    slides.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $(event.target).parent().find('.control-item').removeClass('active');
      $(event.target).parent().find('.control-item').eq(nextSlide).addClass('active');
    });
  } else {
    showingNextProducts = false;
  }
  showingNextProducts = false;
}

if ($('.collection-nav').length > 0) {
  $('.collection-nav').appendTo('.header-container header');
  var timestamp = $('.collection-nav').find('.countdown').data('end-timestamp');
  getCountDown(timestamp, $('.collection-nav').find('.countdown'));
  $(window).on('scroll', function(){
    if ($(window).scrollTop() >= $('.experience-deep-dive').position().top - 50 - 80) {
      $('.collection-nav').removeClass('hide');
      setTimeout(function(){
        //give enough time for css to set display block
        $('body').addClass('collection-nav-active');
      },1);
    } else {
      $('.collection-nav').addClass('hide'); //to prevent seeing bar transition above fold
      $('body').removeClass('collection-nav-active');
    }
  });
  $(window).trigger('scroll');

  $('.expand-row').on('click', function(){
    $(this).parents('.experience-deep-dive').toggleClass('show-all');
  });
}



(function() {
  var c = $('#experienceDetails');

  if(c.length) {
    var timestamp = c.find('header .countdown').data('end-timestamp');

    // Init the count down
    getCountDown(timestamp, c.find('header .countdown'));

    window.setTimeout(function() {
      // Init the scrollbars

      if (c.find('.scrollbar-macosx').length > 0) {
        c.find('.scrollbar-macosx').scrollbar({
          "onInit": function(){
            loadHeader(c);
          }
        });
      } else {
        loadHeader(c);
      }

    }, 1000);

    // Show more products on scroll
    $(window).scroll(function() {
      if(currentPage < c.find('.row').length) {
        var h = $(window).height();
        //var offset = $('.enter-to-win').offset();
        //var offsetTop = offset.top;

        var currentRowOffset = c.find('.row').eq(currentPage - 1).offset();
        var currentRowOffsetTop = currentRowOffset.top;
        var currentRowH = c.find('.row').eq(currentPage - 1).outerHeight();

        if(!showingNextProducts) {
          //if($(document).scrollTop() > offsetTop + $('.enter-to-win').outerHeight() - ($('.row').first().outerHeight()) - $('#topBar').outerHeight() - $('#mainNav').outerHeight()) {
          if($(document).scrollTop() > currentRowOffsetTop - h + currentRowH + $('#shopify-section-header').outerHeight()) {
            currentPage++;
            showNextProducts();
          }
        }
      }
    });

    // Hide / replace elements if the experience ended
    if(!isCollectionLive(timestamp)) {
      console.log('not live')
    }

    // Init the product image carousels
    //initProductImageCarousels();

    showNextProducts();

    function loadHeader(c) {
      c.find('header').addClass('init');
      c.find('header h4').addClass('animate slide-right');
      c.find('header .title-intro').addClass('animate slide-right');
      setTimeout(function() {c.find('header .title-top').addClass('animate slide-right');}, 200);
      setTimeout(function() {c.find('header .title-bottom').addClass('animate slide-right');}, 400);
      setTimeout(function() {c.find('header .caption').addClass('animate slide-right');}, 600);
      setTimeout(function() {c.find('header .ctas').addClass('animate slide-right');}, 800);
      setTimeout(function() {c.find('header .share').addClass('animate slide-right');}, 1000);
    }

    // Dots
    $(document).on('click', '#experienceDetails .control-item', function(e) {
      e.preventDefault();
      $(this).parent().parent().find('.slides').slick('slickGoTo', parseInt($(this).data('goto')) - 1, false);
    });

    // Scroll to the 'enter to win' section
    $(document).on('click', '#experienceDetails .go-to-enter, .collection-nav .go-to-enter', function(e) {
      if(!$(this).hasClass('coming-soon')) {
        $('html, body').animate({ scrollTop: $('.enter-to-win').position().top - $('#shopify-section-header').outerHeight() + $('#topBar').outerHeight() }, 'slow');
      } else {
        // Submit the form to Listrak
        var err = '';
        var form = $('.ctas form')
        form.find('.error').removeClass('active');

        if($('#learn-more-email').val() == '') {
          err = 'Please enter your email.';
        } else {
          if(!validateEmail($('#learn-more-email').val())) {
            err = 'Please enter a valid email.';
          }
        }

        if(err == '') {
          form.submit().addClass('sent');
          $('.ctas .form-sent').addClass('active');
          $('.ctas .btn').css('margin-left', 0);
          $(this).remove();
        } else {
          form.find('.error').text(err).addClass('active');
        }
      }
    });

    // Scroll to the 'cause' section
    $(document).on('click', '#experienceDetails .go-to-cause', function(e) {
      showAllProducts();
      $('html, body').animate({ scrollTop: $('#ourCauses').position().top/* - $('#shopify-section-header').outerHeight()*/ }, 'slow');
    });

    // Add item to the cart
    $(document).on('click', '.add-to-cart', function() {
      if(!$(this).hasClass('adding') && !$(this).hasClass('out-of-stock')) {
        $(this).addClass('adding');

        var itemsToAdd = [];
        itemsToAdd.push(
          {
            id: $(this).data('variant-id'),
            quantity: 1
          }
        );

        addItemsToTheCart(itemsToAdd, $(this));
      }
    });

    // Select an option
    $(document).on('click', '#experienceDetails .options .item', function() {
      $(this).parent().find('.item').removeClass('active');
      $(this).addClass('active');
      var content = $(this).parent().parent();
      var productItem = content.parent().parent();
      var addToCart = content.parent().find('.add-to-cart');

      if(products.length) {
        var option1 = content.find('.options:eq(0) .item.active').data('option');
        var option2 = content.find('.options:eq(1) .item.active').data('option');

        //console.log('option1', option1);
        //console.log('option2', option2);

        var variantId = null;
        $.each(products, function(index, p) {
          if(productItem.data('product-handle') == p.handle) {
            $.each(p.variants, function(index, v) {
              if(v.option1 == option1 && v.option2 == option2) {
                variantId = v.id;
                return false;
              }
            });
          }

          if(variantId != null) {
            return false;
          }
        });

        if(variantId != null) {
          addToCart.removeClass('out-of-stock');

          // Update dom and data to be extra sure some shitty browser won't ignore the new value
          addToCart.attr('data-variant-id', variantId);
          addToCart.data('variant-id', variantId);
        } else {  // Out of stock
          //console.log('Impossible to find the variant id');
          addToCart.addClass('out-of-stock');
        }
      } else {
        console.log('Missing product options data');
      }
    });
  }
})();

if ($('.is-live').length > 0) {
  $('body').addClass('is-live');
}

// Grey blocks need to have the same height
$(window).resize(function() {
  var higherHeight = 0;
  var row = null;
  var column = null;

  $('.enter-to-win .product-details').removeAttr('style');

  $('.enter-to-win .row').each(function(i) {
    higherHeight = 0;
    row = $(this);

    if(row.find('.product-item.visible').length > 1) {
      row.find('.product-item.visible').each(function(j) {
        column = $(this);

        if(column.find('.product-details').height() > higherHeight) {
          higherHeight = column.find('.product-details').height();
        }

        //console.log(i, j, column.find('.content').height(), higherHeight)
      });

      row.find('.product-details').height(higherHeight);
    }
  });
});
$(window).resize();

(function() {
  // User gets redirected from /cart, open the cart
  if(window.location.hash == '#cart') {
    $('html').addClass('cart-open');
  }

  // Open the cart by clicking the cart icon
  $(document).on('click', '.cart-item', function() {
    $('html').addClass('cart-open');
  });

  $('#shopify-section-lf__slider-cart .close').click(function() {
    $('html').removeClass('cart-open');
  });
    
  $('#slider_cart').on('click', '.remove', function() {
    updateQuantity($(this).closest('.product-container').data('id'), 0);
  });
  
  $('#slider_cart').on('change', 'select[name="updates[]"]', function() {
    updateQuantity($(this).closest('.product-container').data('id'), $(this).val());
  });  
})();

function updateQuantity(id, quantity) {
  var updates = {};
  updates[id] = quantity;
  
  $.post({
    url: '/cart/update.js',
    dataType: 'json',
    type: 'post',
    data: { updates: updates },
    success: function(cart) {
      refreshCart(cart);
    }, 
    error: function(XMLHttpRequest) {
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;
      if (response.slice(0,4) === 'All ') {
        response = response.replace('All 1 ', 'All ');
      }
      console.log(response);
    }
  });
}

function refreshCart(cart) {
  if(!cart) {
    $.getJSON('/cart.js', function(cart) {
      generateCartHTML(cart);
    });
  } else {
    generateCartHTML(cart);
  }
}
  
function generateCartHTML(cart) {
  $('#topBar .cart-item span').text(cart.item_count);
  $('#mobileBar .cart-item span').text(cart.item_count);
  $('#slider_cart .products').empty();

  if (cart.items.length == 0) {
    $('#slider_cart .empty').removeClass('hide');
    $('#slider_cart .has-items').addClass('hide');
  } else {
    $('#slider_cart .empty').addClass('hide');
    $('#slider_cart .has-items').removeClass('hide');
    $('#slider_cart .subtotal .right').text(slate.Currency.formatMoney(cart.total_price, theme.moneyFormat));

    $.each(cart.items, function(i, item) {

      var image = item.image.split('.png');
      image = image[0] + '_280x.png' + image[1];

      var price = slate.Currency.formatMoney(item.price, theme.moneyFormat);
      if (item.original_line_price != item.line_price) {
        price += '<s>' + slate.Currency.formatMoney(item.original_price, theme.moneyFormat) + '</s>';
      }

      var quantities = '';
      for (x = 1; x <= 10; x++) {
        var selected = '';
        if (x == item.quantity) {
          selected = 'selected';
        }
        quantities += '<option value="' + x + '" ' + selected + '>' + x + '</option>';
      }
      //console.log(item)
      var productHTML = '';
      productHTML += '<div class="product-container" data-id="' + item.id + '">';
        /*productHTML += '<div class="mobile">';
          productHTML += '<div class="image">';
            productHTML += '<a href="' + item.url + '">';
              productHTML += '<img src="' + image + '" alt="' + item.product_title + '">';
            productHTML += '</a>';
          productHTML += '</div>';
          productHTML += '<div class="info">';
            productHTML += '<a class="title" href="' + item.url + '">' + item.product_title + '</a>';
          productHTML += '</div>';
        productHTML += '</div>';*/
        
        productHTML += '<div class="desktop">';
          productHTML += '<div class="image" style="background-image: url(' + image + ');">';
          productHTML += '</div>';
          
          productHTML += '<div class="right">';
            productHTML += '<div class="info">';

              if(item.product_type != '' && item.product_type != null) {
                productHTML += '<h4 class="orange">' + item.product_type + '</h4>';
              } else {
                productHTML += '<h4 class="orange">' + item.product_title + '</h4>';
              }

              var titleParts = item.product_title.split('. ');
              var entries = titleParts[titleParts.length - 1];
              productHTML += '<h3 class="anton">' + entries + '</h3>';

              if(item.product_description != '') {
                productHTML += '<div class="description">' + item.product_description + '</div>';
              }

              // A product with options must have at least a gender and size
              if(item.variant_options.length > 1) {
                productHTML += '<div class="options">';
                  productHTML += '<div class="item gender active" data-option="' + String(item.variant_options[0]) + '">' + String(item.variant_options[0]).toLowerCase() + '</div>';
                productHTML += '</div>';

                productHTML += '<div class="options">';
                  productHTML += '<div class="item size active" data-option="' + String(item.variant_options[1]) + '">' + String(item.variant_options[1]).toLowerCase() + '</div>';
                productHTML += '</div>';
              }

            productHTML += '</div>';
          productHTML += '</div>';
        productHTML += '</div>';

        productHTML += '<div class="bottom">';
          productHTML += '<div class="price oswald-medium"><span>' + price + '</span> donation</div>';

          productHTML += '<div class="qty oswald-medium">';
            productHTML += '<span>x</span>';

            productHTML += '<div class="quantity">';
              productHTML += '<select name="updates[]" id="updates_' + item.key + '" aria-label="10" class="oswald-medium">';
                  productHTML += quantities;
              productHTML += '</select>';
            productHTML += '</div>';
          productHTML += '</div>';

          productHTML += '<div class="remove oswald-medium">Remove</div>';
        productHTML += '</div>';
      productHTML += '</div>';

      $('#slider_cart .products').append(productHTML);
    });
  }

  $('html').addClass('cart-open');
}
(function() {
  
})();

function adjustItemsHeight() {
  var c = $('#causeItems');
  var h = 0;

  c.find('.grid__item').each(function(i) {
    h = $(this).find('.right .text').outerHeight();

    if($(this).find('.left').outerHeight() > h) {
      h = $(this).find('.left').outerHeight();
      $(this).find('.right .text').addClass('normal-size-text');
    }

    $(this).height(h);
  });
}

$(window).resize(function() {
  adjustItemsHeight();
});

$(window).resize();
(function() {
  $(document).on('click', '.recover', function() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
    $('#createAccount').toggleClass('hide');
  });

  $('#CreateAccountForm input[type="submit"]').click(function(e) {
    e.preventDefault();

    if(!$(this).hasClass('loading')) {
      var email = $('#CreateAccountForm input[type="email"]');

      $('#create_customer .errors').remove();
      if(email.val() == '') {
        $('#create_customer').prepend('<div class="errors"><ul><li>Email can\'t be blank.</li></ul></div>');
      } else {
        if(!validateEmail(email.val())) {
          $('#create_customer').prepend('<div class="errors"><ul><li>Email is invalid.</li></ul></div>');
        } else {
          if ($('input[name="address1"]').val().trim() == '' || 
              $('input[name="city"]').val().trim() == '' || 
              $('input[name="zip"]').val().trim() == '' ) {
                $('#create_customer').prepend('<div class="errors"><ul><li>Please complete address.</li></ul></div>');
            } else {
            if(($('#CreatePassword').val() != $('#VerifyPassword').val()) || $('#CreatePassword').val().trim().length < 5 || $('#VerifyPassword').val().trim().length < 5) {
              $('#create_customer').prepend('<div class="errors"><ul><li>Passwords must be at least 5 characters and be the same.</li></ul></div>');
            } else {
              // Register the email
              $('#joinOurCause #join-email').val(email.val());
              $('#joinOurCause input[name="ContactInfo.FirstName"]').val($('#CreateAccountForm #FirstName').val());
              $('#joinOurCause input[name="ContactInfo.LastName"]').val($('#CreateAccountForm #LastName').val());
              
              $('#joinOurCause form').submit();

              $('#CreateAccountForm input[type="submit"]').addClass('loading').val('Please wait...');

              window.setTimeout(function () {
                var $form = $('#create_customer');
                var app_url = 'https://fanthropic-registration.lfshopify.com';
                var form_data = $form.serialize();
                var redirect_url = window.sessionStorage.getItem('product_url');
                var new_data;
              
                if (redirect_url) {
                  new_data = "".concat(form_data, "&return_to=").concat(redirect_url);
                } else {
                  new_data = "".concat(form_data, "&return_to=https://www.fanthropic.com/account");
                }
              
                $.ajax({
                  url: "".concat(app_url, "/register"),
                  type: 'POST',
                  data: new_data,
                  cache: false,
                  success: function success(_ref) {
                    var login_url = _ref.login_url;
                    window.location.href = login_url;
                  },
                  error: function error(err) {
                    if (err.responseText === 'Repeated email') {
                      $('#create_customer').prepend('<div class="errors"><ul><li>Email already exists.</li></ul></div>');
                    } else {
                      $('#create_customer').prepend('<div class="errors"><ul><li>We had a problem creating your account. Please contact our team.</li></ul></div>');
                    }
              
                    $('#CreateAccountForm input[type="submit"]').removeClass('loading').val('Register');
                  }
                });
              }, 1000);
            }
          }
        }
      }
    }
  });

  $(document).on('click', '#orders .show-details', function() {
    var selectedOrder = $(this).data('order-number');
    var rowHeight = $(this).parent().outerHeight();
    $('#orders .order-item').removeClass('active');
    $('#orders .responsive-table-row').removeClass('active');  // Add border

    if($(this).hasClass('active')) {
      $(this).removeClass('active').text('Details');
    } else {
      $(this).parent().parent().addClass('active');  // Remove border
      $('#orders .show-details').removeClass('active').text('Details');
      $(this).addClass('active').text('Close');

      $('#orders .order-item').each(function() {
        if(selectedOrder == $(this).data('order-number')) {
          $(this).addClass('active');
          $('html, body').animate({ scrollTop: $(this).offset().top - rowHeight - $('#shopify-section-header').outerHeight() }, 'slow');
        }
      });
    }
  });
  
})();
(function() {
  $(document).on('shopify:section:load', function(e) {
    var sectionId = e.detail.sectionId;

    if($('#shopify-section-' + sectionId + ' .ctas').length) {
      $('#shopify-section-' + sectionId + ' .ctas').addClass('animate').addClass('slide-right');
    }
  });
})();
(function () {
  if ($('.modal').length > 0) {
    var openModal = function openModal(link, modal) {

      if ($('.modal.open').attr('id') != modal.attr('id')) {
        closeModal();
        link.addClass('open');
        modal.addClass('open');
        $('html').addClass('modal-open');
      }
    };

    $('.modal-link').click(function () {
      openModal($(this), $('.modal[data-modal=' + $(this).data('modal') + ']'));
    });

    $('.modal .not-content, .modal .close').click(function () {
      closeModal();
    });

    function closeModal() {
     $('.modal.open').removeClass('open');
     $('html').removeClass('modal-open');
     $('html').removeClass('modal-scrollable');
     $('.modal-link.open').removeClass('open');
    }
  }
})();

(function() {

  $('form.validate').submit(function(e) {
    var $form = $(this);
    var error = null;

    // Check for errors
    $(this).find('input.required, select.required, textarea.required').each(function() {
      if (!validateField($(this))) {
        // If this is the first error, save it to focus
        if (!error) {
          error = $(this);
        }
      };
    });

    if (error) {
      e.preventDefault();
      error.focus();
      return false;
    }
  });

  // Remove error states if the error is corrected, without having to click submit
  $('form.validate').on('keyup change', '.input-error', function() {
    validateField($(this));
  });

})();

function validEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function validateField($field) {
  var $form = $field.closest('form');

  switch($field.attr('type')) {
    case 'email':
      if (!validEmail($field.val())) {
        $field.addClass('input-error');
        return false;
      }
      break;

    case 'password':
      // Too short?
      if ($field.val().length < 6) {
        $field.addClass('input-error');
        return false;
      }
      // Does this form have two password fields?
      if ($form.find('input[type="password"]').length > 1) {
        // Do they match?
        if ($form.find('input[type="password"]').eq(0).val() != $form.find('input[type="password"]').eq(1).val()) {
          $form.find('input[type="password"]').addClass('input-error');
          return false;
        }
      }
      break;

    case 'text':
      if ($field.val() == null || $field.val().trim() == '') {
        $field.addClass('input-error');
        if ($field.parents('.selectric-wrapper').length > 0) {
          $field.parents('.selectric-wrapper').addClass('mirror-input-error');
        }
        return false;
      }
      break;

    case 'number':
    if ($field.attr('name') == 'customer_age') {
      if ($field.val() == null || $field.val().trim() == '' || parseInt($field.val()) < 18) {
        $field.addClass('input-error');
        return false;
      }
    } else {
      if ($field.val() == null || $field.val().trim() == '') {
        $field.addClass('input-error');
        return false;
      }
    }

      break;
    default:
      //includes textarea, select
      if ($field.val() == null || $field.val().length == 0 || $field.val().toString().trim() == '') {
        $field.addClass('input-error');
        return false;
      }
      break;
  }

  $field.removeClass('input-error');
  if ($field.parents('.selectric-wrapper').length > 0) {
    $field.parents('.selectric-wrapper').removeClass('mirror-input-error');
  }
  if ($field.attr('type') == 'password' && $form.find('input[type="password"]').length > 1) {
    $form.find('input[type="password"]').removeClass('input-error');
  }

  return true;
}

(function () {
  if ($('.modal').length > 0) {

    $('form#altEntry').submit(function(e){
      e.preventDefault();
      var form = $(this);

      setTimeout(function(){
        if ($('form#altEntry .input-error').length == 0){
          form.find('.error-container').html('').addClass('hide');
          form.find('input[type="submit"]').val('Submitting...').prop('disabled', true);

          $.ajax({
            type: 'POST',
            url: 'https://fanthropic-alt-entry.lfshopify.com',
            data: form.serialize(),
            success: function(){
              console.log('success');
              form.find('input[type="submit"]').val('Submit').prop('disabled', false);
              form.siblings('.entry-received').removeClass('hide');
              form.remove();
            },
            error: function(err){
              console.log('error',err.responseText);

              form.find('input[type="submit"]').val('Submit').prop('disabled', false);
              if (JSON.parse(err.responseText).error == 'Please try again later') {
                //pass along the message
                form.find('.error-container').html('Please try again later').removeClass('hide');
              } else {
                if (JSON.parse(err.responseText).error.indexOf('recaptcha') !== -1) {
                  form.find('.error-container').html('Failed recaptcha verification').removeClass('hide');
                } else {
                  form.find('.error-container').html('There was a problem processing your entry. Please try again.').removeClass('hide');
                }
                
              }
            }
          });
        }
      },1);

      return false;
    });
  }
})();

(function() {
  if ($('.template-product').length === 0 && $('.template-login').length === 0 && $('.template-register').length === 0) {
    sessionStorage.removeItem("product_url");
    return;
  }

  if ($('.template-product').length !== 0) {
    sessionStorage.setItem("product_url", window.location.href);        
  }

})();
(function() {
  $(window).scroll(function() {
    var $wk_auction = $('#wk-auction');
    if ($wk_auction.length === 0) { return; }
    if ($(window).outerWidth() < 768) {
      var window_height = $(window).height();
      var wk_auction_top = $wk_auction.offset().top;
      var $ourCauses = $('[data-our-causes-mobile]');
      var ourCauses_top = $ourCauses.offset().top; 
      var $sticky_bar = $('[data-product-sticky-bar]');
      var scroll_top = $(window).scrollTop();

      if ((scroll_top + window_height) < wk_auction_top + 600 || scroll_top > (ourCauses_top - 300)) {
        $sticky_bar.addClass('revealed');
      } else {
        $sticky_bar.removeClass('revealed');
      }
    }
  });

  $(document).on('click', '[data-product-sticky-bar]', function() {
    var $bidding_form = $('#bidding-form');
    if ($bidding_form.length === 0) { return; }
    var bidding_form_top = $bidding_form.offset().top;
    $('html, body').animate({
      scrollTop: bidding_form_top - 45,
    }, 1000);
  });
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
